import { axiosClient as axios } from './axiosClient';

import {
  ChartOfAccountResultViewModel,
  ChartOfAccountTableResultViewModel,
  ChartOfAccountTypeTableResultViewModel,
  ChartOfAccountViewModel,
} from '@models/ChartOfAccount';
import {
  failureResult,
  ResultViewModel,
  successResult,
} from '@models/common/ResultViewModel';
import { handleAxiosError } from '@utils/axiosErrorHandler';
import { getDataUrl } from '@utils/dataUrls';
import { api } from 'src/config/apiEndpoints';

export const ChartOfAccountService = {
  create: async function (
    chartOfAccount: ChartOfAccountViewModel
  ): Promise<ChartOfAccountResultViewModel | ResultViewModel> {
    const createUrl = `${api.BASE_URL}${api.CHART_OF_ACCOUNTS_ENDPOINT}`;

    try {
      const response = await axios.post(createUrl, chartOfAccount);
      return response.data as ChartOfAccountResultViewModel;
    } catch (error) {
      return handleAxiosError(error);
    }
  },
  getList: async function (
    page?: number,
    pageSize?: number,
    searchFields?: string,
    search?: string,
    filters?: string,
    sortBy?: string,
    sortDirection?: string
  ): Promise<ChartOfAccountTableResultViewModel | ResultViewModel> {
    let dataUrl = getDataUrl(
      api.BASE_URL,
      api.CHART_OF_ACCOUNTS_ENDPOINT,
      page,
      pageSize,
      searchFields,
      search,
      sortBy,
      sortDirection
    );

    if (filters) {
      dataUrl = dataUrl + filters;
    }

    try {
      const response = await axios.get(dataUrl);
      return response.data as ChartOfAccountTableResultViewModel;
    } catch (error) {
      return handleAxiosError(error);
    }
  },
  getById: async function (
    id: number
  ): Promise<ChartOfAccountResultViewModel | ResultViewModel> {
    const dataUrl = `${api.BASE_URL}${api.CHART_OF_ACCOUNTS_ENDPOINT}/${id}`;

    try {
      const response = await axios.get(dataUrl);
      return response.data as ChartOfAccountResultViewModel;
    } catch (error) {
      return handleAxiosError(error);
    }
  },
  getChartOfAccountTypes: async function (): Promise<
    ChartOfAccountTypeTableResultViewModel | ResultViewModel
  > {
    const dataUrl = `${api.BASE_URL}${api.CHART_OF_ACCOUNTS_ENDPOINT}/types`;

    try {
      const response = await axios.get(dataUrl);
      return response.data as ChartOfAccountTypeTableResultViewModel;
    } catch (error) {
      return handleAxiosError(error);
    }
  },
  update: async function (
    id: number,
    category: ChartOfAccountViewModel
  ): Promise<ResultViewModel> {
    const updateUrl = `${api.BASE_URL}${api.CHART_OF_ACCOUNTS_ENDPOINT}/${id}`;

    try {
      const response = await axios.put(updateUrl, category);
      if (response.status === 204) {
        return successResult;
      }

      return failureResult;
    } catch (error) {
      return handleAxiosError(error);
    }
  },
  delete: async function (id: number) {
    const deleteURL = `${api.BASE_URL}${api.CHART_OF_ACCOUNTS_ENDPOINT}/${id}`;

    try {
      const response = await axios.delete(deleteURL);
      if (response.status === 204) {
        return successResult;
      }

      return failureResult;
    } catch (error) {
      return handleAxiosError(error);
    }
  },
};
